<template>
  <div class="dash-upload" :class="[size]">
    <el-upload
      class="picture-uploader"
      action=""
      ref="uploader"
      v-loading="loading"
      :accept="accept"
      :show-file-list="false"
      :http-request="uploadPicture"
      :before-upload="beforeUpload"
    >
      <img v-if="imgUrl" :src="imgUrl" class="picture" />
      <div v-if="!imgUrl">
        <i class="el-icon-plus"></i>
        <p>上传图片</p>
        <p>
          {{ tips || '支持分辨率不低于150k，1MB大小图片，支持PNG,JPG图片' }}
        </p>
      </div>
    </el-upload>
    <div class="utils" :class="[layout]" v-if="imgUrl">
      <div class="btn" @click="triggerUpload">重新上传</div>
      <div class="btn" @click="del">删除</div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import axios from 'axios'
export default {
  name: 'dash-upload',
  data() {
    return {
      loading: false,
      imgUrl: '',
      fileType: ''
    }
  },

  props: {
    // 上传文件的类型
    accept: {
      default: 'image/jpg,image/jpeg,image/png',
      type: String
    },
    // 功能文字位置： bottom / right
    layout: {
      type: String,
      default: 'bottom'
    },
    //尺寸： small / medium / large / square
    size: {
      type: String,
      default: 'small'
    },
    // 已上传文件路径
    mediaUrl: {
      type: String,
      default: ''
    },
    //上传图片类型
    typeString:{
      type:String,
      default:"C"     //C-会刊； P-展品
    },
    tips: {
      type: String,
      default: ''
    },
    // 展商注册上传图片不需要token
    needToken: {
      type: Boolean,
      default: false
    },
    // 是否需要验证人脸
    isFaceRead: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    mediaUrl: function() {
      this.init()
    }
  },

  mounted() {
    this.fileType = this.accept
    this.init()
  },

  methods: {
    init() {
      this.imgUrl = this.mediaUrl
    },
 
    uploadPicture(req) {
      const reader = new FileReader()
      reader.readAsDataURL(req.file)
      reader.onload = () => {
        var suffix = "";
        var _ind = req.file.name.lastIndexOf(".");
            suffix = req.file.name.substr(_ind);
        if (this.isFaceRead) {
          let imgData = new FormData();
          imgData.append('UserName', 'qiuwenyan@eastfair.com');
          imgData.append('UserPwd', 'lkj13*ksjd$kjkj');
          imgData.append('ProjectType', 'Ezt');
          imgData.append('Project', 'fzz');
          imgData.append('PicType', 'avatar');
          imgData.append('ExhID', sessionStorage.getItem('ExhID'));
          imgData.append('Base64Img', reader.result.split(',')[1]);
          //百度接口
          // let url = 'http://139.129.208.14/ai/api/Face/FaceDetect';
          let url = 'https://std.eastfair.com/Faceai/api/Face/FaceDetect';
          //test face
          axios({
            method: 'POST',
            url: url,
            cache: false,
            processData: false,
            contentType: false,
            data: imgData
          }).then(res => {
            if (res.data.status === 'OK') {
              // 上传图片
              const params = {
                suffix:suffix,
                type: this.typeString,
                base64: reader.result.split(',')[1]
              }
              const apiUri = this.needToken? 'uploadimage1': 'uploadImg'
              api[apiUri](params).then(res => {
                if(res.data.code == '200'){
                  var _url = res.data.data.url
                  this.imgUrl = _url
                  this.$emit('update:mediaUrl', _url)
                }else{
                  this.$message.error('图片上传失败')
                }
              }).finally(() => {
                this.loading = false
              })
            } else {
              this.$message.error('请上传正确的人脸')
              this.loading = false
            }
          })
        } else {
          // 上传图片
          const params = {
            suffix:suffix,
            type: this.typeString,
            base64: reader.result.split(',')[1]
          }
          const apiUri = this.needToken? 'uploadimage1': 'uploadImg'
          api[apiUri](params).then(res => {
            if(res.data.code == '200'){
              var _url = res.data.data.url
              this.imgUrl = _url
              this.$emit('update:mediaUrl', _url)
            }else{
              this.$message.error('图片上传失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      }
    },

    beforeUpload(file) {
      // console.log(file,'file')
        this.loading = true
        var status = true
        const isLt2M = file.size / 1024 / 1024 < 1
        if (!isLt2M) {
          this.loading = false
          status = false
          this.$message.error('上传图片不能超过1MB')
        }
        if ( file.type !='image/jpeg' &&  file.type !='image/png'&&  file.type !='image/jpg' ) {
          this.loading = false
          status = false
          this.$message.error('支持PNG,JPG格式')
        }
        //调用[限制图片尺寸]函数
        // this.limitFileWH(400, 400, file).then((res) => {
        //   file.isFlag = res
        //   console.log(file.isFlag,'file.isFlag')
        //   if (file.isFlag) {
        //     // return resolve(true)
        //   } else {
        //     this.loading = false
        //     status = false
        //     // return reject(false)
        //   }
        // })
        return status
    },
    //限制图片尺寸
    limitFileWH(E_width, E_height, file) {
      const _this = this
      let imgWidth = ''
      let imgHight = ''
      const issize = new Promise(function(resolve, reject) {
        const width = E_width
        const height = E_height
        const _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = function(){
          imgWidth = img.width
          imgHight = img.height
          const valid = img.width >= width && img.height >= height
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(() =>{
        return true
      }, () => {
        this.$message.error('上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸是' + imgWidth + '*' + imgHight)
        // _this.$message.warning({
        //   message:'上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸是' + imgWidth + '*' + imgHight,
        //   btn: false
        // })
        return false
      })
      return issize
    },
    triggerUpload() {
      this.$refs.uploader.$refs['upload-inner'].$refs['input'].click()
    },

    del() {
      this.imgUrl = ''
      this.$emit('update:mediaUrl', '')
    }
  }
}
</script>
<style lang="less">
// .dash-upload .picture{
//   width: auto !important;
// }
.dash-upload {
  // width: 230px;
  padding-bottom: 10px;
  position: relative;
}
.dash-upload .picture-uploader .el-upload {
  border: 1px solid #DCDFE6;
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  line-height: 2;
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #000;
  font-weight: 400;
}
.dash-upload .iconAdd {
  color: #000;
  width: 23px;
  height: 23px;
  font-size: 23px;
}
.dash-upload .picture-uploader .el-upload:hover {
  border-color: #f7f7f7;
}
.dash-upload.medium {
  width: 27vw;
}
.dash-upload.large {
  width: 70%;
}
.dash-upload.large-y {
  width: 460px;
}
.dash-upload.square {
  width: 230px;
}
.dash-upload.small .picture-uploader {
  // width: 100%;
  // max-height: 200px;
}
.dash-upload.large .picture-uploader {
  height: 22.778vw;
  width: 100%;
}
.dash-upload.large-y .picture-uploader {
  height: 640px;
  width: 100%;
}
.dash-upload.medium .picture-uploader,
.dash-upload.square .picture-uploader {
  height: 230px;
  width: 230px;
}
.dash-upload.square-small .picture-uploader {
  height: 180px;
  width: 180px;
}
.dash-upload.square-small-a {
  width: 206px;
}
.dash-upload .picture-uploader {
  // height: 100%;
  height: 206px;
  width: 100%;
}
.dash-upload .picture {
  width: 99%;
  height: 100%;
  display: block;
  object-fit: contain;
  max-height: 206px;
}
.dash-upload .utils {
  color: #f7f7f7;
  position: absolute;
  bottom: 12px;
  right: 2px;
  line-height: normal;
}
.dash-upload .utils.right {
  left: 102%;
  bottom: 40px;
  width: 100%;
}
.dash-upload .utils .btn {
  display: inline-block;
  margin-left: 12px;
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
  font-weight: 400;
}
.dash-upload .utils .btn:hover {
  color:#f7f7f7;
}

</style>
